module.exports = __webpack_public_path__ + "static/img/f.99a24157.png";